import React, { useState, useCallback, useEffect, useRef } from 'react';
import { Box, IconButton, InputBase } from '@mui/material';
import { theme } from 'utils/theme';
import PropTypes from 'prop-types';
import SendIcon from '@mui/icons-material/Send';

const ChatInput = ({ onSend, disabled }) => {
  const [message, setMessage] = useState('');
  const inputRef = useRef(null);
  const refocusAfterSend = useRef(false);

  // The input is disabled while the answer loads, which drops focus.
  useEffect(() => {
    if (!disabled && refocusAfterSend.current) {
      refocusAfterSend.current = false;
      inputRef.current?.focus();
    }
  }, [disabled]);

  const handleSend = useCallback(() => {
    const trimmed = message.trim();
    if (!trimmed) {
        return;
    }
    refocusAfterSend.current = true;
    onSend(trimmed);
    setMessage('');
  }, [message, onSend]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <Box
      sx={{
        paddingX: '14px',
        paddingY: '4px',
        backgroundColor: theme.palette.background.paper,
        borderTop: '1px solid',
        borderColor: theme.palette.grey[300],
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <InputBase
        fullWidth
        multiline
        autoFocus
        inputRef={inputRef}
        maxRows={2}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Type your message"
        disabled={disabled}
        value={message}
      />
      <IconButton 
        sx={{ p: '10px' }} 
        aria-label="send" 
        onClick={handleSend} 
        disabled={disabled}>
        <SendIcon />
      </IconButton>
    </Box>
  );
};

ChatInput.propTypes = {
  onSend: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default ChatInput;
